import { createContext } from "react";
import type { AvailableLocales } from "../i18n";

export type ILangContext = {
  currentLang: AvailableLocales;
  setCurrentLang: (lang: AvailableLocales) => void;
} | null;

export const LangContext = createContext<ILangContext>(null);
